// @ts-nocheck
import * as actions from './componentLocatorActions';

export { actions };
